import styled from 'styled-components'

import { helpers } from 'styles'

export const Title = styled.h1`
	position: sticky;
	top: -${helpers.spacing.large};
	display: flex;
	column-gap: ${helpers.spacing.medium};
	align-items: center;
	font-size: ${helpers.font.size.large};
	font-weight: 500;
	justify-content: space-between;
	margin: -${helpers.spacing.large} 0 ${helpers.spacing.medium};
	padding: ${helpers.spacing.xxLarge} 0 ${helpers.spacing.large};
	background-color: ${({ theme }) => theme.color.cardBackground};
	z-index: 3;
`
